// extracted by mini-css-extract-plugin
export var container = "_b6-1";
export var cornerButtonContainer = "_b6-5";
export var disabled = "_b6-2";
export var fileContainer = "_b6-4";
export var hiddenInput = "_b6-3";
export var widthContainer = "_b6-0";